var _circle, _circle2, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _g2, _rect7, _rect8, _rect9, _path2, _path3, _rect0, _rect1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyFiles = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 128 128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 64,
  r: 64,
  fill: "#17171E"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 64,
  r: 63.5,
  stroke: "white",
  strokeOpacity: 0.05
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 51.5L36.3999 17.2308C37.0735 15.8649 38.4643 15 39.9873 15H88.9504C90.5056 15 91.9198 15.9014 92.5764 17.3112L108.5 51.5",
  stroke: "white",
  strokeOpacity: 0.06
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 46,
  y: 9,
  width: 36,
  height: 34,
  rx: 4,
  fill: "white",
  fillOpacity: 0.05
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 46,
  y: 9,
  width: 36,
  height: 34,
  rx: 4,
  fill: "#414150"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 46.5,
  y: 9.5,
  width: 35,
  height: 33,
  rx: 3.5,
  stroke: "white",
  strokeOpacity: 0.05
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 41,
  y: 17,
  width: 46,
  height: 34,
  rx: 4,
  fill: "white",
  fillOpacity: 0.05
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 41,
  y: 17,
  width: 46,
  height: 34,
  rx: 4,
  fill: "#414151"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 17.5,
  width: 45,
  height: 33,
  rx: 3.5,
  stroke: "white",
  strokeOpacity: 0.05
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_10473_33546)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 36,
  y: 27,
  width: 56,
  height: 34,
  rx: 4,
  fill: "white",
  fillOpacity: 0.05
}), /*#__PURE__*/React.createElement("rect", {
  x: 36,
  y: 27,
  width: 56,
  height: 34,
  rx: 4,
  fill: "#414151"
}), /*#__PURE__*/React.createElement("rect", {
  x: 36.5,
  y: 27.5,
  width: 55,
  height: 33,
  rx: 3.5,
  stroke: "white",
  strokeOpacity: 0.05
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_10473_33546)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 37,
  width: 70,
  height: 34,
  rx: 4,
  fill: "#414151"
}), /*#__PURE__*/React.createElement("rect", {
  x: 29.5,
  y: 37.5,
  width: 69,
  height: 33,
  rx: 3.5,
  stroke: "white",
  strokeOpacity: 0.05
}))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 51,
  width: 48,
  height: 3,
  rx: 1.5,
  fill: "white",
  fillOpacity: 0.1
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 58,
  width: 48,
  height: 3,
  rx: 1.5,
  fill: "white",
  fillOpacity: 0.1
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 49,
  y: 44,
  width: 31,
  height: 3,
  rx: 1.5,
  fill: "white",
  fillOpacity: 0.1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 51H41.1826C42.6159 51 43.9397 51.7669 44.6527 53.0104L50.3473 62.9424C51.0603 64.1859 52.3841 64.9528 53.8174 64.9528H75.1826C76.6159 64.9528 77.9397 64.1859 78.6527 62.9424L84.3473 53.0104C85.0603 51.7669 86.3841 51 87.8174 51H109.5V90C109.5 96.6274 104.127 102 97.5 102H31.5C24.8726 102 19.5 96.6274 19.5 90V51Z",
  fill: "#23232F"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.1826 51.5C42.4367 51.5 43.5949 52.1709 44.2188 53.2588L49.9131 63.1914C50.7152 64.5903 52.2049 65.4531 53.8174 65.4531H75.1826C76.7951 65.4531 78.2849 64.5903 79.0869 63.1914L84.7812 53.2588C85.4051 52.1709 86.5633 51.5 87.8174 51.5H109V90C109 96.3513 103.851 101.5 97.5 101.5H31.5C25.1487 101.5 20 96.3513 20 90V51.5H41.1826Z",
  stroke: "white",
  strokeOpacity: 0.06
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 89,
  width: 27,
  height: 3,
  rx: 1.5,
  fill: "white",
  fillOpacity: 0.05
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 83,
  width: 21,
  height: 3,
  rx: 1.5,
  fill: "white",
  fillOpacity: 0.05
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_10473_33546",
  x: 32,
  y: 21,
  width: 64,
  height: 42,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10473_33546"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_10473_33546",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_10473_33546",
  x: 25,
  y: 31,
  width: 78,
  height: 42,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10473_33546"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_10473_33546",
  result: "shape"
})))));
export default SvgEmptyFiles;